import { useState, useEffect } from "react";
import { useCartContext } from "@/contexts/CartProvider";
import {
  shouldShowModalBasedOnTime,
  markModalDisplayed,
} from "@/utils/sessionUtils";
import { CommercePath, useBuildCommerceUrl } from "./useBuildCommerceUrl";

const WELCOME_BACK_MODAL_ACTION_KEY = "welcome_back_modal_last_shown";

export function useWelcomeBackModal() {
  const [isOpen, setIsOpen] = useState(false);
  const {
    state: { cartData },
    getTotalItems,
    shouldShowBadge,
  } = useCartContext();
  const checkoutUrl = useBuildCommerceUrl(CommercePath.PaymentRedirect);

  // Check if modal should be shown on component mount
  useEffect(() => {
    if (typeof window === "undefined") return;

    const canShowBasedOnTime = shouldShowModalBasedOnTime(
      WELCOME_BACK_MODAL_ACTION_KEY,
    );
    const hasCartItems = shouldShowBadge;

    // Show modal if:
    // 1. User has items in cart
    // 2. At least 30 minutes have passed since last display (or never shown)
    // 3. User is on a page where we want to show the modal (not checkout or choose your track)
    const shouldShow =
      hasCartItems &&
      canShowBasedOnTime &&
      !window.location.pathname.includes("/checkout") &&
      !window.location.pathname.includes("/track-select");

    if (shouldShow) {
      // 3 second delay before showing modal
      const timer = setTimeout(() => {
        setIsOpen(true);
        // Mark that the modal has been displayed at this time
        markModalDisplayed(WELCOME_BACK_MODAL_ACTION_KEY);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [shouldShowBadge]);

  const dismissModal = () => {
    setIsOpen(false);
  };

  const handleContinueToCheckout = () => {
    window.location.href = checkoutUrl;
  };

  return {
    isOpen,
    dismissModal,
    handleContinueToCheckout,
    cartData,
    getTotalItems,
  };
}
